import React, { useState } from "react";
import {
  Typography,
  Box,
  Divider,
  Button,
  Grid,
  TextField,
  InputLabel,
  Stack,
  Card,
  CardContent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import axios from "axios";
// import {ReactComponent as AddImage} from '../../../Icons/Add.svg'
import { width } from "@mui/system";
import PostAddIcon from "@mui/icons-material/PostAdd";
import { ReactComponent as FormIcon } from "../../../Icons/CommonFormIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";
import dayjs from "dayjs";

export default function AnnouncementAdd() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const allLanguages = useSelector((state) => state.language.languageList)
  console.log(allLanguages)

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    mode: "onTouched",
  });


  const headerDatas = {
    title : '',
    subtitle : ''
  }

  const [activeLanguagesHeader, setActiveLanguagesHeader] = useState(allLanguages);

  const [header, setHeader] = useState({
    en : { ...headerDatas }
  })


  const addHeaderLanguage = () => {
    const nextLanguage = allLanguages.find(lang => !activeLanguagesHeader.some(active => active.value === lang.value))
    if(nextLanguage){
      setActiveLanguagesHeader((prev) => [...prev, nextLanguage])
      setHeader((prev => ({...prev, [nextLanguage.value] : { ...headerDatas }})))
    }
}

const handleHeadingChange = (e, lang, key) => {
  setHeader((prev) => ({
    ...prev,
    [lang]: {
      ...(prev[lang] || { ...headerDatas }),
      [key]: e.target.value,
    },
  }));
};

  const onSubmit = async (data) => {
    console.log(data);

    const datas = {
      title: data?.title,
      subtitle: data?.subtitle,
      date: moment(data?.dateTime?.$d).format("DD-MM-YYYY,hh:mm A"),
    };

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}addAnnouncement`,
        datas
      );
      console.log(response);
      navigate("/Admin");
    } catch (error) {
      console.log(error);
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Card sx={{ width: '80%', border:'1px solid #E5E7EB', borderRadius:"6px"}}>
        <CardContent style={{ padding: 0, margin: 0 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              borderRadius:'6px 6px 0px 0px'
              
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography variant="h6_1">Announcement details</Typography>
          </Box>

          {/* <Divider /> */}
          <form onSubmit={handleSubmit(onSubmit)}>
          {activeLanguagesHeader.map((lang) => (
            <Box sx={{}} key={lang.value}>
            <Typography sx={{fontWeight : 700, fontSize : '1.4rem', mt : 2, ml : 2}}>{lang.name}</Typography>
            <Box style={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {errors?.title?.[lang.value] ? 'Title*' : 'Title'}
              </InputLabel>
              <Controller
                name={`title.${lang.value}`}
                rules={{ required: true }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                    placeholder={`Title for ${lang.name}`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.title?.[lang.value] ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.title?.[lang.value] ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.title?.[lang.value] ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.title?.[lang.value] ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.title?.[lang.value]) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.title?.[lang.value] ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter title</Typography> : null }
            </Box>

            <Box style={{ padding: "0px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  mt: 3,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
               {errors?.subtitle?.[lang.value] ? 'Subtitle*' : 'Subtitle'}
              </InputLabel>
              <Controller
                 name={`subtitle.${lang.value}`}
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                  <TextField
                    placeholder={`Subtitle for ${lang.name}`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.subtitle?.[lang.value] ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.subtitle?.[lang.value] ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.subtitle?.[lang.value] ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.subtitle?.[lang.value] ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.subtitle?.[lang.value]) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.subtitle?.[lang.value] ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter subtitle</Typography> : null }
            </Box>

            <Divider sx={{mt : 2, mb : 2}}/>
            </Box>
          ))}

          {/* <Box sx={{mt : 2, mb: 2, ml : 2}}>
          <Button variant='contained' onClick={() => addHeaderLanguage()}>Add Language</Button>
          </Box> */}


            <Box style={{ padding: "0px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  mt: 3,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: 'black',
                }}
              >
                {errors?.dateTime ? 'Date & Time*' : 'Date & Time'}
              </InputLabel>
              <Controller
                name="dateTime"
                rules={{ required: true }}
                
                control={control}
                render={({ field }) => (
                  <DateTimePicker
                    {...field}
                    // label="Select Date and Time"

                    renderInput={(props) => (
                      <TextField
                        {...props}
                        error={Boolean(errors?.dateTime) ? true : false}
                        fullWidth
                        inputMode="none"
                        inputProps={{
                          ...props.inputProps,
                          placeholder: "DD/MM/YYYY HH:MM AA",
                        }}
                      />
                    )}
                    sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.dateTime ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.dateTime ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.dateTime ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.dateTime ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    format="DD/MM/YYYY hh:mm A"
                    minDateTime={dayjs()}
                  />
                  
                )}
                
              />
              {errors?.dateTime ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please select Date and Time</Typography> : null }
            </Box>
            <Divider style={{marginTop : '15px'}}/>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0px 17px 13px",
              }}
            >
              <Button
                variant="contained"
                type="submit"
                sx={{
                  padding: "10px 20px 10px 20px",
                  mt: 2,
                  width: "20%",
                  fontSize: 20,
                  backgroundColor: "rgb(14, 94, 132)",
                  ":hover": { bgcolor: "rgb(14, 94, 132)" },
                }}
              >
                Confirm
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
